import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard } from 'lucide-react';

import useParent from '../../../hooks/useParent';
import UnderConstruction from '../UnderContructionWrapper';

const Payment = () => {
  const { currentChild } = useParent();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentChild) {
      navigate('/parent/settings', { state: { label: 'Account Information' } });
    }
  }, [currentChild, navigate]);
  return (
    <UnderConstruction
      icon={<CreditCard size={48} />}
      title="Payments Page Under Construction"
      description="We’re busy wiring up billing and invoice features. Please check back soon!"
    />
  );
};

export default Payment;
